import { initNewrelic } from 'config'
import { reportServiceError } from 'config/reportServiceError'
import { setRequestFailureReporter } from 'utils'
import { logRocket, init as initLogRocket } from './logRocket'
import 'i18n'

const startup = () => {
  setRequestFailureReporter(reportServiceError)
  initLogRocket()
  initNewrelic()
}

export { logRocket, startup }
